import { render, staticRenderFns } from "./patients.vue?vue&type=template&id=81cccf3c&"
import script from "./patients.vue?vue&type=script&lang=js&"
export * from "./patients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81cccf3c')) {
      api.createRecord('81cccf3c', component.options)
    } else {
      api.reload('81cccf3c', component.options)
    }
    module.hot.accept("./patients.vue?vue&type=template&id=81cccf3c&", function () {
      api.rerender('81cccf3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/medical/patients/patients.vue"
export default component.exports